import { useMutation, useQueryClient } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'
import { CONTACTS_LIST_QUERY_KEY } from './useUserContacts'

export const useDeleteUserContact = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (contactId: string) =>
      UsersService.deleteContactById(contactId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CONTACTS_LIST_QUERY_KEY]
      })
    }
  })
}
